import React, { Component } from "react";
import Header from "./pages/Header";
import AboutMe from "./pages/AboutMe";
import Footer from "./pages/Footer";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <Header />
        <AboutMe />
        <Footer />
      </div>
    );
  }
}
export default App;
